import nearley from 'nearley'
import grammar from './signal.js'

class Parser {
  constructor(isSymbol, hasCoins) {
    this.isSymbol = isSymbol
    this.hasCoins = hasCoins
  }

  isIgnored = (word) => {
    return this.ignoredWords.indexOf(word) !== -1
  }

  doParse = (text) => {
    const validWords = text.toLowerCase().split(/\s+/).filter(word => !this.isIgnored(word))
    const validText = validWords.join(' ')
    const parser = new nearley.Parser(nearley.Grammar.fromCompiled(grammar(this.isSymbol)))
    try {
      parser.feed(validText)
    } catch(e) {
      parser.feed('')
    }
    return parser
  }

  createSuggestions = (text) => {
    const parser = this.doParse(text)
    const wants = parser.table[parser.current].wants
    let shownSuggestions = {}
    let suggestionsToShow = []
    this.suggestions(this.hasCoins).map(suggestion => {
      if (suggestion.kind in wants) {
        var showSuggestion = true
        if (suggestion.do_not_show_with != null) {
          suggestion.do_not_show_with.map(conflictingSuggestion => {
            if (conflictingSuggestion in shownSuggestions) {
              showSuggestion = false
            }
          })
        }
        if (suggestion.show_when_last_word_is || suggestion.do_not_show_when_last_word_is) {
          const words = text.toLowerCase().split(/\s/)
          let lastWord = words[words.length - 1]
          if (!lastWord && words.length > 1) {
            lastWord = words[words.length - 2]
          }
          if (lastWord && lastWord === suggestion.show_when_last_word_is) {
            showSuggestion = true
          }
          if (lastWord && lastWord === suggestion.do_not_show_when_last_word_is) {
            showSuggestion = false
          }
        }
        if (showSuggestion) {
          shownSuggestions[suggestion.kind] = suggestion
          suggestionsToShow.push(suggestion)
        }
      }
    })
    return suggestionsToShow
  }

  ignoredWords = ['if', 'a', 'the', 'its', 'than', 'already', 'also', 'too',
    'still', 'when', 'whenever', 'it', 'it\'s', 'their', 'them', 'that', 'then']

  suggestions = (hasCoins) => hasCoins
    ? this.suggestionsMain
    : this.suggestionsMain.concat([{
      'kind': 'microeconomic_tag',
      'values': ['Fundamentals (Type # to insert)'],
      'do_not_show_when_last_word_is': 'is',
      'open_modal': true,
      'symbol': '#'
    },
    {
      'kind': 'sentiment_alternative_tag',
      'values': ['Alternative data (Type & to insert)'],
      'do_not_show_when_last_word_is': 'is',
      'open_modal': true,
      'symbol': '&'
    }])

  suggestionsMain =  [
    { 'kind': 'ago', 'values': ['ago'], 'substitute_suggestion': true },
    {
      'kind': 'moving_average',
      'values': ['Market Data (Type @ to insert)'],
      'do_not_show_when_last_word_is': 'is',
      'open_modal': true,
      'symbol': '@'
    },
    {
      'kind': 'logical_operator',
      'do_not_show_with': ['moving_average'],
      'substitute_suggestion': true,
      'values': ['and', 'or']
    },
    {
      'kind': 'equals',
      'values': ['is equal to'],
      'substitute_suggestion': true,
      'show_before': ['greater_than_with_percentage']
    },
    {
      'kind': 'equals__equals_to_part',
      'values': ['equal to'],
      'substitute_suggestion': true,
      'do_not_show_with': ['equals'],
      'show_before': ['greater_than_with_percentage']
    },
    {
      'kind': 'greater_than',
      'do_not_show_with': ['moving_average'],
      'values': ['is above', 'is 10% above'],
      'substitute_suggestion': true
    },
    {
      'kind': 'greater_than_with_percentage',
      'show_when_last_word_is': 'is',
      'do_not_show_with': ['moving_average', 'greater_than'],
      'values': ['10% above'],
      'substitute_suggestion': true,
      'show_before': ['less_than_with_percentage']
    },
    {
      'kind': 'greater_than__above_part',
      'show_when_last_word_is': 'is',
      'do_not_show_with': ['moving_average', 'greater_than'],
      'values': ['above'],
      'substitute_suggestion': true,
      'show_before': ['less_than__below_part']
    },
    {
      'kind': 'less_than',
      'do_not_show_with': ['moving_average'],
      'values': ['is below', 'is 10% below'],
      'substitute_suggestion': true
    },
    {
      'kind': 'less_than_with_percentage',
      'show_when_last_word_is': 'is',
      'do_not_show_with': ['moving_average', 'less_than'],
      'values': ['10% below'],
      'substitute_suggestion': true
    },
    {
      'kind': 'less_than__below_part',
      'show_when_last_word_is': 'is',
      'do_not_show_with': ['moving_average', 'less_than'],
      'values': ['below'],
      'substitute_suggestion': true,
      'show_before': ['equals__equals_to_part']
    },
    {
      'kind': 'cross_up',
      'do_not_show_with': ['moving_average'],
      'values': ['crosses above'],
      'substitute_suggestion': true
    },
    {
      'kind': 'cross_down',
      'do_not_show_with': ['moving_average'],
      'values': ['crosses below'],
      'substitute_suggestion': true,
      'show_before': ['addition_operator', 'miltiplication_operator']
    },
    {
      'kind': 'addition_operator',
      'do_not_show_with': ['moving_average'],
      'values': ['+', '-'],
      'substitute_suggestion': true,
      'show_before': ['multiplication_operator'],
      'type': 'math'
    },
    {
      'kind': 'multiplication_operator',
      'do_not_show_with': ['moving_average'],
      'values': ['*', '/'],
      'substitute_suggestion': true,
      'type': 'math'
    },
    {
      'kind': 'days_back_day_ago_part',
      'values': ['days', 'months'],
      'substitute_suggestion': true,
      'show_before': ['greater_than', 'less_than', 'cross_up', 'cross_down',
        'addition_operator', 'multiplication_operator', 'equals']
    },
    {
      'kind': 'num_days_day_part',
      'do_not_show_with': ['days_back_day_ago_part'],
      'values': ['days', 'weeks', 'months'],
      'substitute_suggestion': true
    }
  ]
}

export default Parser
